import React, { useEffect } from 'react'
import { Switch } from 'antd'

import { useAppSelector } from '_src/store/hooks'
import { initTheme } from '_src/themes'
import { useTranslation } from 'react-i18next'

import './index.less'

const Theme = () => {
  const { t } = useTranslation()
  const { theme } = useAppSelector((store) => store.global)

  const onChange = (checked) => {
    if (checked) {
      initTheme('dark')
    } else {
      initTheme('light')
    }
  }

  useEffect(() => {
    initTheme(theme || 'dark')
  }, [])

  return (
    <div className="cust-theme">
      <span style={{ marginRight: '25px' }}>{t('common.night_mode')}</span>
      <Switch onChange={onChange} className="cust-switch" defaultChecked={theme == 'dark' ? true : false} />
    </div>
  )
}

export default Theme
